export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-2.8041d553.png";